import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import './style.css';
import { ReportsCounters } from '../../../shared/types';

const COLORS = ['#DB4437', '#25D368', '#4267b2']; // Google, Facebook, Mobile colors

const LoginMethodRidersChart = ({ data }) => {
    const [countersData, setCountersData] = useState<ReportsCounters>();
    const [isMobile, setIsMobile] = useState(false);
    const LOGIN_METHOD_LABELS = {
        GOOGLE: 'Google',
        FACEBOOK: 'Facebook',
        PHONE: 'Phone',
    };
    const chartData = (countersData?.loginMethods || []).map((item) => ({
        ...item,
        name: LOGIN_METHOD_LABELS[item.loginMethod] || item.loginMethod,
    }));
    useEffect(() => {
        setCountersData(data);
    }, [data]);

    // Detect screen size
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 480);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div
            style={{
                width: '100%',
                maxWidth: '500px',
                margin: '0 auto',
                height: isMobile ? 260 : 310,
                background: '#fff',
                borderRadius: '16px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                padding: isMobile ? '10px' : '16px',
            }}
        >
            <h3
                style={{
                    textAlign: 'center',
                    marginBottom: 10,
                    fontSize: isMobile ? '13px' : '14px',
                    fontWeight: 600,
                }}
            >
                Login Method of Riders
            </h3>
            <ResponsiveContainer width="100%" height="80%">
                <PieChart width={300} height={300}>
                    <Pie
                        data={chartData}
                        dataKey="total"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        innerRadius={isMobile ? 40 : 60}
                        outerRadius={isMobile ? 70 : 100}
                        paddingAngle={3}
                        label={false}
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>

                    <Tooltip />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default LoginMethodRidersChart;
